import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { analyticsApi } from 'src/services/analyticsApi'

interface SaveMonitoringPagePayload {
  ad_reached_countries?: string[]
  ad_type?: string
  page_id: string
  page_name?: string
}

const saveMonitoringPage = async (
  payload: SaveMonitoringPagePayload
): Promise<void> => {
  await analyticsApi().post('/v1_private/ads-library/monitoring-pages', payload)
}

export const useSaveMonitoringPageMutation = (options?: {
  onError?: (error: unknown) => void
  onSuccess?: () => void
}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: saveMonitoringPage,
    onError: options?.onError,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_MONITORING_PAGES],
      })
      // Detail page summary flips from not_monitored -> pending after save;
      // refetch so the StatsCards picks it up and starts polling.
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_ADS_LIBRARY_PAGE_SUMMARY],
      })
      options?.onSuccess?.()
    },
  })
}
